export default function () {
  const $calculatorClass = '.calculator';
  const $pricingCalculatorSection = $($calculatorClass);
  let pricingCalculatorInitiated = false;

  function formatCurrency(value) {
    const language = $('html').attr('lang');
    if (language === 'gb') {
      return '£' + parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,').toString();
    } else {
      return parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1.').toString().replace(/.([^.]*)$/, ',$1') + ' €';
    }
  }

  function calculateTotal() {
    if (pricingCalculatorInitiated) {
      $pricingCalculatorSection.removeClass('calculator-initial');
    }

    const users = Number($($calculatorClass + ' .calculator-category-users .slider-input').val());
    const checkboxOption = $($calculatorClass + ' .calculator-category-option').data('option') === 2;
    const priceToggle = $($calculatorClass + ' .toggle-switch input[type=checkbox]')[0];
    const summaryWrapper = $($calculatorClass + ' .calculator-summary-wrapper');
    let sumMonthly = 0;
    let sumOneTime = 0;
    let priceListEntriesMonthly = '';
    let priceListEntriesOneTime = '';
    let showOneTime = false;
    let linkBase = summaryWrapper.data('signup-link-base');
    let linkParameterProduct = 'voice';
    let linkParameterPeriod = '_24';
    let linkParameterFlatrate = '';

    const $flatrates = $($calculatorClass + ' .calculator-category-flatrates');
    let flatratesSumMonthly = 0;
    if ($flatrates.find('.calculator-flatrates-limited')) {
      const flatratesLimitedText = $flatrates.find('.calculator-flatrates-limited');
      const flatratesOptionText = $flatrates.find('.calculator-flatrates-option');
      const flatratesLimitedValue = Number($flatrates.data('flatrates-limited-activation'));
      if (flatratesLimitedValue > users || checkboxOption) {
        if (flatratesLimitedValue > users && !checkboxOption) {
          flatratesLimitedText.show();
        } else {
          flatratesLimitedText.hide();
        }
        if (checkboxOption) {
          flatratesOptionText.show();
          $flatrates.data('flatrate-selection', 'included');
          linkParameterFlatrate = $flatrates.data('signup-parameter-flat');
        } else {
          flatratesOptionText.hide();
          $flatrates.data('flatrate-selection', 'none');
        }
        $flatrates.find('.calculator-tile-selected').removeClass('calculator-tile-selected');
        $flatrates.find('.calculator-tile').addClass('calculator-tile-disabled');
      } else {
        flatratesLimitedText.hide();
        flatratesOptionText.hide();
        $flatrates.data('flatrate-selection', 'none');
        $flatrates.find('.calculator-tile').removeClass('calculator-tile-disabled');
        $flatrates.find('.calculator-tile').each(function () {
          const $tile = $(this);
          if ($tile.hasClass('calculator-tile-selected') && users > 0) {
            $flatrates.data('flatrate-selection', $tile.data('flatrate-slug'));
            flatratesSumMonthly += users * Number($tile.data('price-monthly'));
            linkParameterFlatrate = $flatrates.data('signup-parameter-flat');
          }
        });
      }
    }
    $flatrates.data('total-monthly', flatratesSumMonthly);

    const $integrations = $($calculatorClass + ' .calculator-category-integrations');
    let integrationsSumMonthly = 0;
    let integrationsSumAmount = 0;
    let integrationsArray = [];
    $integrations.find('.calculator-tile').each(function () {
      const $tile = $(this);
      $tile.removeClass('calculator-tile-hidden');
      const $availability = $tile.data('availability');
      const amount = Number($tile.find('.amount-input').val());

      if (checkboxOption && $availability === 'without' || !checkboxOption && $availability === 'with') {
        $tile.addClass('calculator-tile-hidden');
      }

      if (!amount || !$tile.hasClass('calculator-tile-selected')) {
        return;
      }

      if (!(checkboxOption && $availability === 'without' || !checkboxOption && $availability === 'with')) {
        integrationsSumMonthly += amount * Number($tile.data('price-monthly'));
        integrationsSumAmount += amount;
        integrationsArray.push({
          'slug': $tile.data('integration-slug'),
          'count': amount,
        });
      }
    });

    $integrations.data('total-monthly', integrationsSumMonthly);
    $integrations.data('total-onetime', 0);

    const $integrations2 = $($calculatorClass + ' .calculator-category-integrations2');
    let integrations2SumMonthly = 0;
    let integrations2SumAmount = 0;
    $integrations2.find('.calculator-tile').each(function () {
      const $tile = $(this);
      const amount = Number($tile.find('.amount-input').val());
      if ($tile.hasClass('calculator-tile-selected') && amount > 0) {
        integrations2SumMonthly += amount * Number($tile.data('price-monthly'));
        integrations2SumAmount += amount;
      }
    });
    $integrations2.data('total-monthly', integrations2SumMonthly);
    $integrations2.data('total-onetime', 0);

    const $hardware = $($calculatorClass + ' .calculator-category-hardware');
    const checkboxMonthly = $hardware.find('#hardware-monthly').prop('checked');
    let hardwareSumMonthly = 0;
    let hardwareSumOneTime = 0;
    let hardwareSumAmount = 0;
    $hardware.find('.calculator-tiles-hardware-selected .calculator-tile').each(function () {
      const $tile = $(this);
      const amount = Number($tile.find('.amount-input').val());
      if ($tile.hasClass('calculator-tile-selected') && amount > 0) {
        if (checkboxMonthly) {
          hardwareSumMonthly += amount * Number($tile.data('price-monthly'));
        } else {
          hardwareSumOneTime += amount * Number($tile.data('price-onetime'));
        }
        hardwareSumAmount += amount;
      }
    });
    $hardware.data('total-monthly', hardwareSumMonthly);
    $hardware.data('total-onetime', hardwareSumOneTime);

    const $sims = $($calculatorClass + ' .calculator-category-sims');
    let simsSumMonthly = 0;
    let simsSumOneTime = 0;
    let simsSumAmount = 0;
    $sims.find('.calculator-tile').each(function () {
      const $tile = $(this);
      const amount = Number($tile.find('.amount-input').val());
      if ($tile.hasClass('calculator-tile-selected') && amount > 0) {
        simsSumMonthly += amount * Number($tile.data('price-monthly'));
        simsSumOneTime += Number($tile.data('price-onetime'));
        simsSumAmount += amount;
      }
    });

    $sims.data('total-monthly', simsSumMonthly);
    $sims.data('total-onetime', simsSumOneTime);

    if (checkboxOption) {
      $($calculatorClass + ' .calculator-category-sims .calculator-tile-selected img').each(function () {
        $(this).click();
      });
    }

    $($calculatorClass + ' .calculator-category:not(.calculator-category-option, .calculator-category-summary)').each(function () {
      const $this = $(this);
      let monthly = Number($this.data('total-monthly'));
      const onetime = Number($this.data('total-onetime'));
      const value = Number($this.data('value'));
      let text = value === 1 ? $this.data('summary') : $this.data('summary-plural');
      let replaceValue = value;
      let flatText = '';
      let freeClassMonthly = '';
      let freeClassOneTime = '';

      if ($this.data('flat-activated') && $this.data('flat-activation') && Number($this.data('flat-activation')) <= value * Number($this.data('price-monthly'))) {
        flatText = ' <span class="calculator-summary-prices-flat-text">' + $this.data('flat-activated') + '</span>';
        text = users === 1 ? $this.data('summary-flat') : $this.data('summary-flat-multiple');
      }

      if (checkboxOption && text === '{{value}} Mobile SIM') {
        // in some conditions the amount volume does not update
        simsSumAmount = 0;
      }

      if ($this.hasClass('calculator-category-users')) {
        if (checkboxOption) {
          text = users === 1 ? $this.data('option-summary') : $this.data('option-summary-plural');
          $this.find('.calculator-intro-users').html($this.data('option-intro-text'));
        } else {
          text = users === 1 ? $this.data('summary') : $this.data('summary-plural');
          $this.find('.calculator-intro-users').html($this.data('intro-text'));
        }
      } else if ($this.hasClass('calculator-category-integrations')) {
        replaceValue = integrationsSumAmount;
        text = replaceValue === 1 ? $this.data('summary') : $this.data('summary-plural');
      } else if ($this.hasClass('calculator-category-integrations2')) {
        replaceValue = integrations2SumAmount;
        text = replaceValue === 1 ? $this.data('summary') : $this.data('summary-plural');
      } else if ($this.hasClass('calculator-category-hardware')) {
        replaceValue = hardwareSumAmount;
        text = replaceValue === 1 ? $this.data('summary') : $this.data('summary-plural');
      } else if ($this.hasClass('calculator-category-sims')) {
        replaceValue = simsSumAmount;
        text = replaceValue === 1 ? $this.data('summary') : $this.data('summary-plural');
      }

      if (monthly !== 0 || $this.data('show-zero-monthly') === 1) {
        if (monthly === 0 && $this.data('show-zero-monthly') === 1) {
          freeClassMonthly = ' class="calculator-summary-price-free"';
        }
        if (checkboxOption && monthly > 0 && (
            text === 'Flatrates' ||
            text === 'MS-Teams'
          )) {
          monthly = 0;
        }
        priceListEntriesMonthly += '<li' + freeClassMonthly + '><div>' + text.replace('{{value}}', replaceValue).replace('{{users}}', users) + flatText + '</div><div>' + formatCurrency(monthly) + '</div></li>';
      }
      if (onetime !== 0 || $this.data('show-zero-one-time') === 1) {
        if (onetime === 0 && $this.data('show-zero-one-time') === 1) {
          freeClassOneTime = ' class="calculator-summary-price-free"';
          showOneTime = true;
        }
        priceListEntriesOneTime += '<li' + freeClassOneTime + '><div>' + text.replace('{{value}}', replaceValue).replace('{{users}}', users) + '</div><div>' + formatCurrency(onetime) + '</div></li>';
      }

      sumMonthly += monthly;
      sumOneTime += onetime;
    });

    $($calculatorClass + ' .calculator-summary-prices-monthly').html((priceListEntriesMonthly !== '' ? priceListEntriesMonthly : ''));
    $($calculatorClass + ' .calculator-summary-prices-one-time').html((priceListEntriesOneTime !== '' ? priceListEntriesOneTime : ''));
    $($calculatorClass + ' .calculator-summary-total-price-wrapper-monthly .calculator-summary-total-price span').html(formatCurrency(sumMonthly));
    $($calculatorClass + ' .calculator-summary-total-price-wrapper-one-time .calculator-summary-total-price span').html(formatCurrency(sumOneTime));
    if (sumOneTime > 0 || showOneTime) {
      $($calculatorClass + ' .calculator-summary-one-time').removeClass('calculator-summary-one-time-hide');
    } else {
      $($calculatorClass + ' .calculator-summary-one-time').addClass('calculator-summary-one-time-hide');
    }

    if (checkboxOption) {
      summaryWrapper.addClass('calculator-summary-with-option');
      linkParameterProduct = summaryWrapper.data('signup-parameter-product-2');
    } else {
      summaryWrapper.removeClass('calculator-summary-with-option');
      linkParameterProduct = summaryWrapper.data('signup-parameter-product-1');
    }

    if (priceToggle && priceToggle.checked === false) {
      linkParameterPeriod = summaryWrapper.data('signup-parameter-period-2');
    } else {
      linkParameterPeriod = summaryWrapper.data('signup-parameter-period-1');
    }

    // Change Signup Link
    $($calculatorClass + ' .calculator-summary-total-wrapper .btn-call2action').attr('href', linkBase + '?' + linkParameterProduct + linkParameterPeriod + linkParameterFlatrate);

    // Cookie
    if (pricingCalculatorInitiated) {
      let calculatorData = {
        product: {
          type: checkboxOption ? 'suite' : 'voice',
          count: users,
        },
        flatrate: {
          type: $flatrates.data('flatrate-selection'),
        },
        integrations: integrationsArray,
      };
      let date = new Date();
      date.setTime(date.getTime() + (24 * 60 * 60 * 1000 * 60)); // set for 60 days
      document.cookie = 'websiteCalculatorData=' + JSON.stringify(calculatorData) + ';expires=' + date.toUTCString() + '; path=/';
    }

    pricingCalculatorInitiated = true;
  }

  function syncSliderValue($this, type) {
    const range = $this.parent().parent().find('.slider-range');
    const bubble = $this.parent().parent().find('.slider-bubble');
    const input = $this.parent().parent().find('.slider-input');
    const value = $this.val();
    const $section = $this.closest('.calculator');
    const bulletPosition = (Number(value - Number($this.attr('min'))) / (Number($this.attr('max')) - Number($this.attr('min'))));
    const bulletPositionPercent = (Number(value - Number($this.attr('min'))) / (Number($this.attr('max')) - Number($this.attr('min')))) * 100;
    bubble.find('.slider-bubble-text').html(value + ' ' + bubble.data('text'));
    bubble.css({ left: (bulletPosition * (range.width() - 60)) + 48 + 'px' });
    if ($section.hasClass('dark-background')) {
      range.css({ background: 'linear-gradient(to right, var(--color-neutral-600) 0%, var(--color-neutral-600) ' + bulletPositionPercent + '%, var(--color-neutral-700) ' + bulletPositionPercent + '%, var(--color-neutral-700) 100%)' });
    } else {
      range.css({ background: 'linear-gradient(to right, var(--color-neutral-400) 0%, var(--color-neutral-400) ' + bulletPositionPercent + '%, var(--color-neutral-300) ' + bulletPositionPercent + '%, var(--color-neutral-300) 100%)' });
    }
    if (type === 'range') {
      input.val(value);
    } else {
      range.val(value);
    }
    bubble.removeClass('slider-bubble-hide');
  }

  function inputChanges($this) {
    event.preventDefault();
    const value = $this.val();
    const $category = $this.closest('.calculator-category');
    const users = $($calculatorClass + ' .calculator-category-users .slider-input').val();
    const amount = Number(value);
    const perUser = ($category.data('price-per-user') === 1 && !$category.hasClass('calculator-category-users')) ? amount * users : amount;

    if ($category.hasClass('calculator-category-users')) {
      const checkboxOption = $($calculatorClass + ' .calculator-category-option').data('option') === 2;
      const alternatePrice = $($calculatorClass + ' .toggle-switch input[type=checkbox]').length ? $($calculatorClass + ' .toggle-switch input[type=checkbox]').prop('checked') : false;
      let price = checkboxOption ? (!alternatePrice ? Number($category.data('price-option-monthly-alternate')) : Number($category.data('price-option-monthly'))) : (!alternatePrice ? Number($category.data('price-monthly-alternate')) : Number($category.data('price-monthly')));
      let total = price * perUser;
      $category.data('total-monthly', total);

      price = checkboxOption ? Number($category.data('price-option-onetime')) : Number($category.data('price-onetime'));
      total = price * perUser;
      $category.data('total-onetime', total);

      if ($category.find('.calculator-individual-offer')) {
        const individualOfferText = $category.find('.calculator-individual-offer');
        const individualOfferValue = Number($category.data('individual-offer-activation'));
        if (individualOfferValue <= users) {
          individualOfferText.show();
        } else {
          individualOfferText.hide();
        }
      }
      /*} else if ($category.hasClass('calculator-category-minutes')) {
        const activationText = $category.find('.calculator-flat-activated');
        const flatValue = Number($category.data('flat-activation'));
        if (flatValue <= value * Number($category.data('price-monthly'))) {
          $category.data('total-monthly', flatValue * users);
          activationText.show();
        } else {
          const price = Number($category.data('price-monthly'));
          const total = price * perUser;
          $category.data('total-monthly', total);
          activationText.hide();
        }*/
    } else {
      let price = Number($category.data('price-monthly'));
      let total = price * perUser;
      $category.data('total-monthly', total);

      price = Number($category.data('price-onetime'));
      total = price * perUser;
      $category.data('total-onetime', total);
    }
    $category.data('value', value);
    if ($this.hasClass('slider-input')) {
      syncSliderValue($this, 'input');
    }
  }

  if ($pricingCalculatorSection.length) {
    calculateTotal();
    document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + 'px');

    $($calculatorClass + ' input[type="range"]').each(function () {
      const $this = $(this);
      syncSliderValue($this, 'range');
    });

    $($calculatorClass + ' input').change(function () {
      $($calculatorClass + ' input').each(function () {
        inputChanges($(this));
      });
      calculateTotal();
    });

    $pricingCalculatorSection.on('input', 'input[type="range"]', function () {
      const $this = $(this);
      if ($this.attr('type') === 'range') {
        syncSliderValue($this, 'range');
      }
    });

    $($calculatorClass + ' .calculator-tile-image').click(function () {
      const $tile = $(this).parent();
      $tile.toggleClass('calculator-tile-selected');
      if ($tile.data('category')) {
        $($calculatorClass + ' .calculator-tiles-hardware').removeClass('calculator-tiles-hardware-first').removeClass('calculator-tiles-hardware-last');
        $($calculatorClass + ' .calculator-tiles-hardware-' + $tile.data('category')).toggleClass('calculator-tiles-hardware-selected');
        $($calculatorClass + ' .calculator-tiles-hardware:visible:first').addClass('calculator-tiles-hardware-first');
        $($calculatorClass + ' .calculator-tiles-hardware:visible:last').addClass('calculator-tiles-hardware-last');
      } else if ($tile.closest('.calculator-category').hasClass('calculator-category-flatrates') || $tile.closest('.calculator-category').hasClass('calculator-category-option')) {
        $tile.siblings().removeClass('calculator-tile-selected');
        if ($tile.closest('.calculator-category').hasClass('calculator-category-option')) {
          $tile.addClass('calculator-tile-selected');
          $($calculatorClass + ' .calculator-category-option').data('option', $tile.data('option'));
          inputChanges($('#users-input'));
        }
      }
      calculateTotal();
    });

    $($calculatorClass + ' .calculator-tile-button').click(function () {
      const $this = $(this);
      const isNegative = $this.hasClass('calculator-tile-button-minus');
      const input = $this.parent().find('.amount-input');
      input[0][isNegative ? 'stepDown' : 'stepUp']();
      calculateTotal();
    });

    $($calculatorClass + ' .calculator-progress-button').click(function () {
      const $this = $(this);
      $this.blur();
      if (!$this.prop('disabled')) {
        const $container = $this.closest('.section-container');
        const steps = parseInt($container.attr('data-steps'));
        let step = parseInt($container.attr('data-step'));
        const next = $this.hasClass('calculator-progress-button-next');
        if (next) {
          step += 1;
        } else {
          step -= 1;
        }
        $container.attr('data-step', step);
        if (step <= 1) {
          $($calculatorClass + ' .calculator-progress-button-previous').prop('disabled', true);
        } else {
          $($calculatorClass + ' .calculator-progress-button-previous').prop('disabled', false);
        }
        if (step >= steps) {
          $($calculatorClass + ' .calculator-progress-button-next').prop('disabled', true);
        } else {
          $($calculatorClass + ' .calculator-progress-button-next').prop('disabled', false);
        }
      }
    });
  }
}
